import map from 'lodash/map'
import Chart from '../../core/components/Chart'
import { colors } from '../utils/colors'
import StatisticsEmptyPieChart from './StatisticsEmptyPieChart'
import { AdvertType } from '../../academy/types'
import { ChartData } from 'chart.js'

export type Props = {
    data: AdvertType[]
    field: keyof AdvertType
    loading: boolean
}

export default function StatisticsAcademySalesChannelChart({ data, field, loading }: Props) {
    if (!data.some((item) => item[field] !== 0) && !loading) {
        return <StatisticsEmptyPieChart />
    }

    return (
        <Chart
            loading={loading}
            type="doughnut"
            height="500px"
            data={{
                labels: data ? map(data, 'name') : [],
                datasets: [{
                    data: data ? map(data, field) : [],
                    backgroundColor: colors,
                }],
            } as ChartData}
            options={{
                legend: { position: 'bottom' },
                animation: {
                    animateScale: true,
                    animateRotate: true,
                },
                plugins: {
                    datalabels: {
                        color: '#000',
                        font: { weight: 'bold' },
                    },
                },
            }} />
    )
}
